import React from 'react';
import { Table, message, Modal, Radio } from 'antd';
import dayjs from 'dayjs';

export default () => {
    const [ dataSource, setDataSource ] = React.useState([]);
    const [ miniList, setMiniList ] = React.useState([]);
    const [ selectedAccId, setSelectedAccId ] = React.useState();

    const getTemplateList = async () => {
        const response = await fetch('/api/sys/template-list');
        const result = await response.json();

        if(result?.success) {
            return result?.data?.template_list;
        }
    };

    React.useEffect(() => {

        getTemplateList().then(data => {
            if(data) setDataSource(data);
        });
    }, []);

    const columns = [
        {
            title: '版本',
            dataIndex: 'user_version',
        },
        {
            title: '创建时间',
            dataIndex: 'create_time',
            render: (text) => <div>{dayjs(text * 1000).format('YYYY-MM-DD HH:mm:ss')}</div>,
        },
        {
            title: '开发者',
            dataIndex: 'developer',
        }
    ];

    return (
        <div>
            * 预发是指上传代码并生成体验版
            <Table rowKey="template_id" columns={columns} dataSource={dataSource} />
        </div>
    )
}